import { render, staticRenderFns } from "./ConfiguratorHeadlightType.vue?vue&type=template&id=abab6f9a"
import script from "./ConfiguratorHeadlightType.vue?vue&type=script&lang=js"
export * from "./ConfiguratorHeadlightType.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorHeadlightType.vue?vue&type=style&index=0&id=abab6f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default})
